/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolPaletteIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-palette"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M11.88 22.8Q9.65 22.8 7.67 21.95Q5.7 21.1 4.24 19.64Q2.77 18.18 1.93 16.2Q1.07 14.22 1.07 12Q1.07 9.75 1.94 7.78Q2.8 5.8 4.3 4.34Q5.8 2.88 7.8 2.04Q9.8 1.2 12.07 1.2Q14.28 1.2 16.24 1.96Q18.2 2.73 19.69 4.06Q21.18 5.4 22.05 7.21Q22.93 9.03 22.93 11.15Q22.93 14.47 20.77 16.09Q18.63 17.7 15.97 17.7L14.72 17.7Q14.65 17.7 14.59 17.76Q14.53 17.82 14.53 17.9Q14.53 18.05 14.78 18.43Q15.03 18.8 15.03 19.55Q15.03 20.9 14.09 21.85Q13.15 22.8 11.88 22.8ZM6.28 13.3Q6.28 13.3 6.65 13.3Q7.03 13.3 7.55 12.78Q8.07 12.25 8.07 11.5Q8.07 10.75 7.55 10.22Q7.03 9.7 6.28 9.7Q5.53 9.7 5 10.22Q4.47 10.75 4.47 11.5Q4.47 12.25 5 12.78Q5.53 13.3 6.28 13.3ZM9.32 9.2Q9.32 9.2 9.7 9.2Q10.07 9.2 10.6 8.68Q11.13 8.15 11.13 7.4Q11.13 6.65 10.6 6.13Q10.07 5.6 9.32 5.6Q8.57 5.6 8.05 6.13Q7.53 6.65 7.53 7.4Q7.53 8.15 8.05 8.68Q8.57 9.2 9.32 9.2ZM14.43 9.2Q14.43 9.2 14.8 9.2Q15.18 9.2 15.7 8.68Q16.23 8.15 16.23 7.4Q16.23 6.65 15.7 6.13Q15.18 5.6 14.43 5.6Q13.68 5.6 13.15 6.13Q12.63 6.65 12.63 7.4Q12.63 8.15 13.15 8.68Q13.68 9.2 14.43 9.2ZM17.52 13.3Q17.52 13.3 17.9 13.3Q18.27 13.3 18.8 12.78Q19.32 12.25 19.32 11.5Q19.32 10.75 18.8 10.22Q18.27 9.7 17.52 9.7Q16.77 9.7 16.25 10.22Q15.72 10.75 15.72 11.5Q15.72 12.25 16.25 12.78Q16.77 13.3 17.52 13.3Z" fill={color} />
    </svg>
  );
}
